import type { ConvexQueryClient } from "@convex-dev/react-query";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { ConvexReactClient } from "convex/react";
import { Toaster } from "sonner";

import { ThemeProvider } from "../components/theme-provider";

// Auth state passed from React hooks to router context
// This enables beforeLoad guards to check auth before component code runs
export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  userId: string | null | undefined;
  orgId: string | null | undefined;
}

export interface RouterContext {
  queryClient: QueryClient;
  convexClient: ConvexReactClient;
  convexQueryClient: ConvexQueryClient;
  auth: AuthState;
}

function RootComponent() {
  return (
    <ThemeProvider>
      <Outlet />
      <Toaster />
    </ThemeProvider>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
